export const state = {
  cohorts: [],
  isLoading: false,
  totalRecords: 0,
  cohortPerPage: 10000,
  activePage: 1
}
